import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Academy } from './pages/Academy';
import { Certifications } from './pages/Certifications';
import { Troubleshoot } from './pages/Troubleshoot';
import { CaseHistory } from './pages/CaseHistory';
import { Profile } from './pages/Profile';
import { LandingPage } from './pages/LandingPage';
import { PasswordProtect } from './pages/PasswordProtect';
import { AppProvider } from './context/AppContext';

function App() {
  // isAuthorized: User has entered the correct system password
  const [isAuthorized, setIsAuthorized] = useState(false);
  // isAuthenticated: User has "logged in" from the landing page to access the dashboard
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleVerify = () => {
    setIsAuthorized(true);
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <AppProvider>
      <Router>
        {!isAuthorized ? (
          <Routes>
            <Route path="/" element={<PasswordProtect onVerify={handleVerify} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : !isAuthenticated ? (
          <Routes>
            <Route path="/" element={<LandingPage onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="academy" element={<Academy />} />
              <Route path="certifications" element={<Certifications />} />
              <Route path="troubleshoot" element={<Troubleshoot />} />
              <Route path="history" element={<CaseHistory />} />
              <Route path="profile" element={<Profile />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        )}
      </Router>
    </AppProvider>
  );
}

export default App;